// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"LoaderComp_loaderWrapper__MDIZu","cubeWrapper":"LoaderComp_cubeWrapper__BDJ+F","cube":"LoaderComp_cube__xr7nh","rotateCube":"LoaderComp_rotateCube__-c+dV"};